<template>
    <div id="wrapper">
      <MainHeader :show-menu="true" />
      <div id="page-reduced" class="grid-container">
        <slot />
      </div>
      <!--<MainFooter />-->
    </div>
  </template>
  
  <script>
  import MainHeader from "@/components/layout/Header.vue"
  //import MainFooter from "@/components/Footer.vue"
  
  export default {
    name: "DefaultLayout",
    components: { MainHeader }
  }
  </script>
  
  